<template>
  <div class="profile">
    <div class="container">
      <div class="menu">
        <div class="menu-title">个人中心</div>
        <div
          :class="{ 'menu-item': true, 'menu-item-cur': menuIndex == 0 }"
          @click="changeMenu(0)"
        >
          <img
            :src="require('../../public/images/profile/collect.png')"
            alt=""
            class="menu-icon"
          />
          我的收藏
        </div>
        <div
          :class="{ 'menu-item': true, 'menu-item-cur': menuIndex == 1 }"
          @click="changeMenu(1)"
        >
          <img
            :src="require('../../public/images/profile/note.png')"
            alt=""
            class="menu-icon"
          />
          我的笔记
        </div>
        <div
          :class="{ 'menu-item': true, 'menu-item-cur': menuIndex == 2 }"
          @click="changeMenu(2)"
        >
          <img
            :src="require('../../public/images/profile/history.png')"
            alt=""
            class="menu-icon"
          />
          历史检索
        </div>
      </div>
      <div class="content">
        <div class="calendar">
          <div class="month">
            <img
              :src="require('../../public/images/profile/last.png')"
              alt=""
              class="arrow"
              @click="lastMonth"
            />
            {{ year }}年{{ month }}月
            <img
              :src="
                year == maxYear && month == maxMonth
                  ? require('../../public/images/profile/next_disable.png')
                  : require('../../public/images/profile/next.png')
              "
              alt=""
              class="arrow"
              @click="nextMonth"
            />
          </div>
          <div class="calendar-row">
            <div class="calendar__day">日</div>
            <div class="calendar__day">一</div>
            <div class="calendar__day">二</div>
            <div class="calendar__day">三</div>
            <div class="calendar__day">四</div>
            <div class="calendar__day">五</div>
            <div class="calendar__day">六</div>
          </div>
          <div class="calendar-row">
            <div
              class="date"
              v-for="(item, index) in date"
              :key="`${item.month}${item.date}`"
              @click="chooseDate(index)"
            >
              <div
                :class="{
                  'date-num': true,
                  'date-num-otherMonth': item.month != month,
                  today:
                    item.date === dateNow &&
                    item.month === maxMonth &&
                    item.year === maxYear,
                  'choose-date': index == chooseIndex,
                }"
              >
                {{ item.date }}
              </div>
              <div v-if="item.hasNote" class="date-dot"></div>
            </div>
          </div>
        </div>
        <div class="date-title">
          {{ curMonth }}月{{ curDate }}日
          <div v-if="menuIndex != 1" class="date-delete" @click.stop="delAll">
            全部删除
          </div>
        </div>
        <div
          class="history-item"
          v-for="(item, index) in history"
          :key="index"
          @click="onDataItemClick(item)"
        >
          <div class="history-item-title">
            {{ item.name || item.searchCriteria }}
          </div>
          <div
            v-if="menuIndex != 1"
            class="history-delete"
            @click.stop="delItem(item)"
          >
            删除
          </div>
          <div v-if="menuIndex == 1" class="note-box">
            <div
              :class="{ 'note-item': true, 'note-item-nodata': !item.thinkNm }"
            >
              <img
                :src="
                  require(`../../public/images/profile/${
                    item.thinkNm ? 'idea' : 'noIdea'
                  }.png`)
                "
                alt=""
              />
              {{ item.thinkNm || 0 }}
            </div>
            <div
              :class="{ 'note-item': true, 'note-item-nodata': !item.dashNum }"
            >
              <img
                :src="
                  require(`../../public/images/profile/${
                    item.dashNum ? 'underline' : 'noUnderline'
                  }.png`)
                "
                alt=""
              />
              {{ item.dashNum || 0 }}
            </div>
            <div class="note-line"></div>
            <div class="note-item note-xinde" @click.stop="toEditXinde(item)">
              <img
                :src="require('../../public/images/profile/xinde.png')"
                alt=""
              />
              心得
            </div>
          </div>
        </div>
        <div v-if="isEmpty" class="no-data">
          <img
            class="no-data-img"
            :src="require('../../public/images/noData.png')"
            alt=""
          />
          <div class="no-data-text">{{ hintText[menuIndex] }}</div>
        </div>
      </div>
    </div>
    <div v-if="xindeShow" class="mask">
      <div class="xinde-box">
        <div class="xinde-title">
          心得
          <div
            class="close"
            @click="
              xindeShow = false
              xinde = ''
            "
          ></div>
        </div>
        <textarea
          class="xinde-textarea"
          placeholder="写下此刻的想法..."
          v-model="xinde"
          maxlength="1000"
        ></textarea>
        <div class="xinde-length">{{ xinde.length }}/1000</div>
        <div class="xinde-button" @click="confirmXinde">完成</div>
      </div>
    </div>
    <div v-if="xywShow" class="xyw-mask">
      <div class="xyw">
        <div class="xyw-close" @click="xywShow = false"></div>
        <div class="xyw-title">
          <img
            :src="require('../../public/images/tips.png')"
            alt=""
            class="xyw-tips"
          />
          提示
        </div>
        <div class="xyw-des">
          <div>您当前未连接校园网，</div>
          <div>请连接后使用“马克思主义大辞典”检索资源库！</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  findCollectionTime,
  findCollection,
  findNote,
  findNoteTime,
  findHistoricalSearchTime,
  findHistoricalSearch,
  batchDelCollection,
  batchDelSeach,
  getUserArticle,
  submitExperience,
  getBaiMingDanByIp,
} from '../service/api'
import { getUserInfo } from '../utils/utils'

export default {
  name: 'Profile',
  //   props: ['menuIndex'],
  data: () => {
    return {
      xywShow: false,
      menuIndex: 0,
      year: 2022,
      month: 8,
      maxMonth: 0,
      maxYear: 0,
      curYear: 2022,
      curMonth: 8,
      curDate: '',
      date: [],
      oldDate: [],
      isFirst: true,
      noteTime: [],
      chooseIndex: -1,
      dateNow: 0,
      history: [],
      userInfo: {},
      isEmpty: false,
      hintText: [
        '这一天你没有收藏任何内容哦',
        '这一天你没有添加任何笔记哦',
        '这一天你没有检索任何内容哦',
      ],
      xindeShow: false,
      xinde: '',
      selectedArticleId: null,
    }
  },
  async mounted() {
    // let date = new Date()
    // let year = date.getFullYear()
    // let month = date.getMonth() + 1
    // let dateNow = date.getDate()
    // this.year = year
    // this.month = month
    // this.maxYear = year
    // this.maxMonth = month
    // this.curYear = year
    // this.curMonth = month
    // this.curDate = dateNow
    // this.dateNow = dateNow
    // // this.getDateArray(year, month)
    // this.userInfo = await getUserInfo()
    // if (!this.userInfo) {
    //   this.$router.replace({ path: '/' })
    // }
    // this.changeMenu(this.$route.query.menuIndex)
    this.refreshPage(this.$route.query.menuIndex)
  },
  watch: {
    $route(to, from) {
      console.log('to', to.query.menuIndex)
      this.refreshPage(to.query.menuIndex)
    },
  },
  methods: {
    async refreshPage(idx) {
      if (this.isFirst) {
        console.log('this.isFirst')
        let date = new Date()
        let year = date.getFullYear()
        let month = date.getMonth() + 1
        let dateNow = date.getDate()
        this.year = year
        this.month = month
        this.maxYear = year
        this.maxMonth = month
        this.curYear = year
        this.curMonth = month
        this.curDate = dateNow
        this.dateNow = dateNow
      }
      this.isFirst = false
      // this.getDateArray(year, month)
      this.userInfo = await getUserInfo()
      if (!this.userInfo) {
        this.$router.replace({ path: '/' })
      }
      this.changeMenu(idx)
    },
    changeMenu(index) {
      this.menuIndex = Number(index)
      this.history = []
      switch (Number(index)) {
        case 0: {
          findCollectionTime(this.userInfo.uid).then((res) => {
            let noteTime = []
            res.data.data.forEach((item) => {
              noteTime.push(item.newtime)
            })
            this.noteTime = noteTime
            this.getDateArray(this.year, this.month)
            // 今天有数据则加载
            // let today = this.getFormateDate(this.year, this.month, this.dateNow)
            // if (noteTime.includes(today)) {
            //   this.refreshList(0)
            // } else {
            //   this.isEmpty = true
            // }
            this.refreshList(0)
          })
          break
        }
        case 1: {
          findNoteTime(this.userInfo.uid).then((res) => {
            let noteTime = []
            res.data.data.forEach((item) => {
              noteTime.push(item.newtime)
            })
            this.noteTime = noteTime
            this.getDateArray(this.year, this.month)
            // 今天有数据则加载
            // let today = this.getFormateDate(this.year, this.month, this.dateNow)
            // if (noteTime.includes(today)) {
            //   this.refreshList(1)
            // } else {
            //   this.isEmpty = true
            // }
            this.refreshList(1)
          })
          break
        }
        case 2: {
          findHistoricalSearchTime(this.userInfo.uid).then((res) => {
            let noteTime = []
            res.data.data.forEach((item) => {
              noteTime.push(item.newtime)
            })
            this.noteTime = noteTime
            this.getDateArray(this.year, this.month)
            // 今天有数据则加载
            // let today = this.getFormateDate(this.year, this.month, this.dateNow)
            // if (noteTime.includes(today)) {
            //   this.refreshList(2)
            // } else {
            //   this.isEmpty = true
            // }
            this.refreshList(2)
          })
          break
        }
      }
    },
    refreshList(index) {
      switch (index) {
        case 0: {
          findCollection(
            this.getFormateDate(this.curYear, this.curMonth, this.curDate),
            this.userInfo.uid
          ).then((res) => {
            this.history = res.data.data
            this.isEmpty = res.data.data.length == 0
          })
          break
        }
        case 1: {
          findNote(
            this.getFormateDate(this.curYear, this.curMonth, this.curDate),
            this.userInfo.uid
          ).then((res) => {
            this.history = res.data.data
            this.isEmpty = res.data.data.length == 0
          })
          break
        }
        case 2: {
          findHistoricalSearch(
            this.getFormateDate(this.curYear, this.curMonth, this.curDate),
            this.userInfo.uid
          ).then((res) => {
            this.history = res.data.data
            this.isEmpty = res.data.data.length == 0
          })
          break
        }
      }
    },
    getDaysInOneMonth(year, month) {
      month = parseInt(month, 10)
      var day = new Date(year, month, 0)
      return day.getDate()
    },
    getFormateDate(year, month, date) {
      return `${year}-${month < 10 ? '0' + month : month}-${
        date < 10 ? '0' + date : date
      }`
    },
    getDateArray(year, month) {
      let date = []
      let firstDay = new Date(year, month - 1, 1).getDay()
      let dayInThisMonth = this.getDaysInOneMonth(year, month)
      let lastMonthLastDate = this.getDaysInOneMonth(year, month - 1)
      // 上月日期
      for (let i = 0; i < firstDay; i++) {
        date.push({
          year,
          month: month - 1,
          date: lastMonthLastDate - firstDay + i + 1,
        })
      }
      // 本月日期
      for (let i = 0; i < dayInThisMonth; i++) {
        date.push({
          year,
          month: month,
          date: i + 1,
        })
      }
      if (dayInThisMonth + firstDay < 35) {
        for (let i = 0; i < 35 - dayInThisMonth - firstDay; i++) {
          date.push({
            year,
            month: month + 1,
            date: i + 1,
          })
        }
      } else if (dayInThisMonth + firstDay > 35) {
        for (let i = 0; i < 42 - dayInThisMonth - firstDay; i++) {
          date.push({
            year,
            month: month + 1,
            date: i + 1,
          })
        }
      }
      // 循环查询是否有笔记
      date.forEach((item) => {
        if (
          this.noteTime.indexOf(
            this.getFormateDate(item.year, item.month, item.date)
          ) > -1
        ) {
          item.hasNote = true
        }
      })
      let oldDate = this.oldDate
      let curIndex = -1
      if (this.isFirst) {
        curIndex = date.findIndex(
          (item) =>
            item.date === this.curDate &&
            item.month === this.curMonth &&
            item.year === this.curYear
        )
        this.oldDate = [year, month, curIndex]
      }
      if (oldDate[0] == year && oldDate[1] == month) {
        curIndex = oldDate[2]
      }
      this.date = date
      this.chooseIndex = curIndex
      console.log('curIndex', this.chooseIndex)

      if (this.isFirst) {
        this.isFirst = true
        // this.triggerEvent('chooseDate', {date: this.getFormateDate(date[curIndex].year, date[curIndex].month, date[curIndex].date)})
      }
    },
    chooseDate(index) {
      if (
        this.date[index].year !== this.year ||
        this.date[index].month !== this.month
      ) {
        return
      }
      this.chooseIndex = index
      this.oldDate = [this.date[index].year, this.date[index].month, index]
      this.curYear = this.date[index].year
      this.curMonth = this.date[index].month
      this.curDate = this.date[index].date
      this.refreshList(this.menuIndex)
    },
    lastMonth() {
      let { month, year } = this
      if (month > 1) {
        this.getDateArray(year, month - 1)
        this.month = month - 1
      } else {
        this.getDateArray(year - 1, 12)
        this.month = 12
        this.year = year - 1
      }
    },
    nextMonth() {
      let { month, year, maxYear, maxMonth } = this
      if (year == maxYear && month == maxMonth) {
        return false
      }
      if (month === 12) {
        this.getDateArray(year + 1, 1)
        this.month = 1
        this.year = year + 1
      } else {
        this.getDateArray(year, month + 1)
        this.month = month + 1
        this.year = year
      }
    },
    async onDataItemClick(item) {
      switch (Number(this.menuIndex)) {
        case 0:
        case 1: {
          let ipRes = await getBaiMingDanByIp()
          if (ipRes.data.data.baimingdan == 'no') {
            this.xywShow = true
            return
          }
          this.$router.push({
            path: '/read',
            query: { id: item.articleId, type: this.menuIndex },
          })
          break
        }
        case 2: {
          this.$router.push({
            path: '/',
            query: { entry: item.searchCriteria },
          })
          break
        }
      }
    },
    delItem(item) {
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        if (this.menuIndex == 0) {
          batchDelCollection([item.collectionId]).then((res) => {
            if (res.data.result) {
              this.$message.success('删除成功')
              this.refreshList(0)
            }
          })
        } else if (this.menuIndex == 2) {
          batchDelSeach([item.id]).then((res) => {
            if (res.data.result) {
              this.$message.success('删除成功')
              this.refreshList(2)
            }
          })
        }
      })
    },
    delAll() {
      this.$confirm('确认全部删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then((res) => {
        if (this.menuIndex == 0) {
          let ids = []
          this.history.forEach((item) => {
            ids.push(item.collectionId)
          })
          batchDelCollection(ids).then((res) => {
            if (res.data.result) {
              this.$message.success('删除成功')
              this.refreshList(0)
            }
          })
        } else if (this.menuIndex == 2) {
          let ids = []
          this.history.forEach((item) => {
            ids.push(item.id)
          })
          batchDelSeach(ids).then((res) => {
            if (res.data.result) {
              this.$message.success('删除成功')
              this.refreshList(2)
            }
          })
        }
      })
    },
    toEditXinde(item) {
      this.xindeShow = true
      this.selectedArticleId = item.articleId
      getUserArticle(this.userInfo.uid, item.articleId, 2).then((res) => {
        if (res.data.data.userThink && res.data.data.userThink.length > 0) {
          this.xinde = res.data.data.userThink[0].content
        }
      })
    },
    confirmXinde() {
      if (this.xinde.length == 0) {
        this.$message.error('请输入心得')
        return
      }
      submitExperience(
        this.selectedArticleId,
        this.xinde,
        [],
        '[]',
        this.userInfo.uid
      ).then((res) => {
        if (res.data.data.status) {
          this.$message.success('保存成功!')
          this.xindeShow = false
        }
      })
    },
  },
}
</script>

<style lang="less">
.profile {
  width: 100vw;
  min-width: 1334px;
  background-color: #f5f5f5;
  overflow-x: hidden;

  .container {
    display: flex;
    width: 1334px;
    margin: 30px auto 0;
  }

  .menu {
    width: 440px;
    height: calc(100vh - 80px);
    background-color: #fff;

    .menu-title {
      height: 82px;
      text-align: center;
      line-height: 82px;
      font-size: 22px;
      color: #333;
    }

    .menu-item {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      width: 440px;
      height: 80px;
      padding-left: 30px;
      background: #fff;
      color: #333;
      font-size: 18px;
      cursor: pointer;
      &:hover {
        color: #a10f0f;
      }
    }

    .menu-item-cur {
      background-color: #ffe6e6;
    }

    .menu-icon {
      width: 25px;
      height: 25px;
      margin-right: 12px;
    }
  }

  .content {
    width: 868px;
    margin-left: 26px;
  }

  .calendar {
    width: 868px;
    height: 422px;
    background: #ffffff;
    overflow: hidden;
  }

  .month {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 26px;

    .arrow {
      width: 18px;
      height: 18px;
      margin: 0 20px;
      cursor: pointer;
    }

    color: #333;
    font-size: 18px;
  }

  .calendar-row {
    display: flex;
    flex-flow: row wrap;
    width: 630px;
    margin: 0 auto;
  }

  .calendar__day {
    flex: 1;
    text-align: center;
    line-height: 60px;
    color: #c0c0c0;
    font-size: 18px;
  }

  .date {
    position: relative;
    width: 90px;
    margin-bottom: 20px;
    text-align: center;
    font-size: 16px;
    color: #333;
    cursor: pointer;
  }

  .date-num {
    width: 32px;
    height: 32px;
    line-height: 32px;
    border-radius: 16px;
    margin: 0 auto 10px;
  }

  .date-num-otherMonth {
    color: #999;
  }

  .today {
    background-color: #f58181;
    color: #fff;
  }

  .choose-date {
    background-color: #c22828;
    color: #fff;
  }

  .date-dot {
    position: absolute;
    left: 50%;
    top: 34px;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #c22828;
    transform: translateX(-50%);
  }

  .date-title {
    position: relative;
    text-align: left;
    line-height: 63px;
    margin-top: 15px;
    padding-left: 32px;
    font-size: 22px;
    color: #333;
  }

  .date-delete {
    position: absolute;
    right: 0;
    top: 0;
    width: 100px;
    text-align: center;
    line-height: 63px;
    color: #666666;
    font-size: 16px;
    cursor: pointer;
  }

  .history-item {
    box-sizing: border-box;
    position: relative;
    width: 868px;
    height: 70px;
    padding-left: 30px;
    text-align: left;
    margin-bottom: 10px;
    background: #ffffff;
    font-size: 16px;
    color: #333;
    line-height: 70px;
    font-weight: 400;
    cursor: pointer;
    .history-item-title {
      &:hover {
        color: #000;
        font-weight: bold;
      }
    }

    .note-box {
      display: flex;
      position: absolute;
      top: 0;
      right: 16px;

      .note-line {
        width: 2px;
        height: 29px;
        margin-top: 19px;
        margin-right: 12px;
        background: #cecece;
      }

      .note-item {
        display: flex;
        flex-flow: column;
        align-items: center;
        justify-content: center;
        height: 70px;
        margin-right: 14px;
        line-height: 24px;
        font-size: 12px;
        color: #666;

        img {
          width: 24px;
          height: 24px;
        }
      }

      .note-item-nodata {
        color: #ccc;
      }
    }
  }

  .history-delete {
    position: absolute;
    right: 0;
    top: 0;
    width: 100px;
    text-align: center;
    line-height: 70px;
    color: #666666;
    flex-wrap: nowrap;
    font-size: 16px;
    cursor: pointer;
    &:hover {
      color: #000;
      font-weight: bold;
    }
  }

  .no-data {
    width: 100%;
    height: 300px;
    overflow: hidden;

    .no-data-img {
      display: block;
      width: 191px;
      height: 142px;
      margin: 42px auto 10px;
    }

    .no-data-text {
      text-align: center;
      font-size: 14px;
      color: #808080;
    }
  }

  .mask {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.2);
  }

  .xinde-box {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 680px;
    height: 290px;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border-radius: 20px;

    .xinde-title {
      box-sizing: border-box;
      width: 680px;
      height: 58px;
      line-height: 58px;
      padding-left: 30px;
      background-color: #f5f5f5;
      font-size: 22px;
      font-weight: 400;
      color: #1a1a1a;
      border-radius: 20px 20px 0 0;
    }

    .close {
      position: absolute;
      top: 14px;
      right: 22px;
      width: 30px;
      height: 30px;
      cursor: pointer;

      &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 20px;
        height: 2px;
        background-color: #868686;
        transform: translate(-50%, -50%) rotate(45deg);
      }

      &::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 20px;
        height: 2px;
        background-color: #868686;
        transform: translate(-50%, -50%) rotate(-45deg);
      }
    }

    .xinde-textarea {
      display: block;
      width: 620px;
      height: 150px;
      margin: 0 auto;
      padding: 18px 0;
      font-size: 16px;
      resize: none;
      border: none;
      outline: none;
    }

    .xinde-length {
      padding-left: 30px;
      font-size: 14px;
      color: #808080;
    }

    .xinde-button {
      position: absolute;
      bottom: 30px;
      right: 30px;
      width: 104px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      font-size: 16px;
      color: #fff;
      background: #c22828;
      border-radius: 18px;
      cursor: pointer;
      user-select: none;
    }
  }

  .xyw-mask {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 2;
    .xyw {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 720px;
      height: 258px;
      background: #ffffff;
      border-radius: 20px;
      transform: translate(-50%, -50%);
      .xyw-close {
        position: absolute;
        top: 0;
        right: 0;
        width: 63px;
        height: 63px;
        cursor: pointer;
        &::before {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          width: 20px;
          height: 2px;
          background-color: #868686;
          transform: translate(-50%, -50%) rotate(45deg);
        }
        &::after {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          width: 20px;
          height: 2px;
          background-color: #868686;
          transform: translate(-50%, -50%) rotate(-45deg);
        }
      }
      .xyw-title {
        display: flex;
        align-items: center;
        height: 62px;
        padding-top: 20px;
        font-size: 22px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #1a1a1a;
        line-height: 42px;
        .xyw-tips {
          width: 24px;
          height: 24px;
          margin: 0 10px 0 50px;
        }
      }
      .xyw-des {
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #4d4d4d;
        line-height: 44px;
        text-align: center;
      }
    }
  }
}
</style>
